export default __webpack_public_path__ + "static/media/groundtruth-logo-hamburger.26072f76.svg";